import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-950">
      <div className="px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl font-bold text-foreground-950">
                奸
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">奸情影视大全</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-700">
              专注于情感纠葛题材的电影与电视剧，提供剧情介绍、演员资料与最新影视资讯，帮助影迷快速了解并深入查找感兴趣的影视作品。本站内容为演示示例，不提供播放入口。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold uppercase tracking-widest text-accent-400">浏览导航</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 transition-colors hover:text-foreground-950">首页</Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-700 transition-colors hover:text-foreground-950">影视分类</Link>
              </li>
              <li>
                <Link to="/news" className="text-foreground-700 transition-colors hover:text-foreground-950">影视资讯</Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-700 transition-colors hover:text-foreground-950">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold uppercase tracking-widest text-accent-400">内容分类</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/category?category=电影" className="text-foreground-700 transition-colors hover:text-foreground-950">电影作品</Link>
              </li>
              <li>
                <Link to="/category?category=电视剧" className="text-foreground-700 transition-colors hover:text-foreground-950">电视剧集</Link>
              </li>
              <li>
                <Link to="/category?genre=悬疑" className="text-foreground-700 transition-colors hover:text-foreground-950">悬疑题材</Link>
              </li>
              <li>
                <Link to="/category?genre=爱情" className="text-foreground-700 transition-colors hover:text-foreground-950">爱情题材</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-700">© 2026 奸情影视大全 · 内容仅供演示参考</p>
          <p className="text-xs text-foreground-700">剧情介绍 · 演员信息 · 影视资讯</p>
        </div>
      </div>
    </footer>
  );
}